import artifacts from './StakingCampaignPayment.json';
import { BigNumber, Contract } from 'ethers';
import { ContractLoader } from '../helpers/ContractLoader';
import { durationToUnit, DurationUnits, Duration, createDuration } from '../helpers/duration';

export class StakingCampaignPayment {
  contract: Contract | null;
  loader: ContractLoader;

  constructor() {
    this.loader = new ContractLoader({
      name: 'StakingCampaignPayment',
      bytecode: artifacts.bytecode,
      abi: artifacts.abi,
    });

    this.contract = null;
  }

  async load(address: string): Promise<void> {
    this.contract = await this.loader.load(address);
  }

  async deploy(
    stakingToken: string,
    rewardsTokens: Array<string>,
    stakeLimit: BigNumber,
    throttleRoundDuration: Duration,
    throttleRoundCap: BigNumber,
    contractStakeLimit: BigNumber,
    name: string,
    paymentContract: string,
  ): Promise<void> {
    const throttleRoundSeconds = durationToUnit(throttleRoundDuration, DurationUnits.seconds);

    this.contract = await this.loader.deploy([
      stakingToken,
      rewardsTokens,
      stakeLimit,
      throttleRoundSeconds,
      throttleRoundCap,
      contractStakeLimit,
      name,
      paymentContract,
    ]);
  }
}
